import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

export function image(node: PMNode): {
	alt: string | undefined;
	title: string | undefined;
	type: 'image';
	url: string;
} {
	const url: string = (node.attrs.src as string) ?? '';
	const alt: string | undefined = (node.attrs.alt as string) ?? undefined;
	const title: string | undefined = (node.attrs.title as string) ?? undefined;
	return {
		type: 'image' as const,
		url,
		alt,
		title,
	};
}
